import { render, staticRenderFns } from "./addShippingAccount.vue?vue&type=template&id=3bb0c324&"
import script from "./addShippingAccount.vue?vue&type=script&lang=js&"
export * from "./addShippingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports